export interface ComponentIdentityImageSpecification {
	id: number;
	imageUrl: string;
	altText: string;
}

export class ComponentIdentityImage {
	public readonly id: number;
	public readonly imageUrl: string;
	public readonly altText: string;

	constructor(spec: ComponentIdentityImageSpecification) {
		this.id = spec.id;
		this.imageUrl = spec.imageUrl;
		this.altText = spec.altText;
	}
}
